"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPurchaseMotionData = exports.fetchMerchandiseCatalog = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var _dispatchAndThrowError = require("pricing-pages-unified-ui/utils/dispatchAndThrowError");

var _getProductsNoAuth = require("self-service-api/api/getProductsNoAuth");

// edition values are received in uppercase and need to be set to
// lowercase for use on the pricing page. May want to consider
// a better solution later so we do not have to do this every time
var merchandandiseCatalogAdapter = function merchandandiseCatalogAdapter(catalog) {
  var products = catalog.products;
  Object.keys(products).forEach(function (merchandiseId) {
    var edition = products[merchandiseId].edition;

    if (edition) {
      products[merchandiseId].edition = edition.toLowerCase();
    }
  });
};

var fetchMerchandiseCatalog = function fetchMerchandiseCatalog() {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.default.MERCHANDISE_REQUESTED
    });
    return (0, _getProductsNoAuth.getProducts)({
      apiGetter: window.quickFetch.getRequestStateByName('merchandise')
    }).then(function (catalog) {
      merchandandiseCatalogAdapter(catalog);
      dispatch({
        type: _ActionTypes.default.MERCHANDISE_RECEIVED,
        payload: catalog.products
      });
    }).catch(function (error) {
      (0, _dispatchAndThrowError.dispatchAndThrowError)({
        dispatch: dispatch,
        type: _ActionTypes.default.MERCHANDISE_FAILED,
        error: error
      });
    });
  };
};

exports.fetchMerchandiseCatalog = fetchMerchandiseCatalog;

var fetchPurchaseMotionData = function fetchPurchaseMotionData(getPurchaseMotions) {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.default.PURCHASE_MOTION_DATA_REQUESTED
    });
    return getPurchaseMotions().then(function (data) {
      var _data$metadata = data.metadata,
          customerCurrencyCode = _data$metadata.customerCurrencyCode,
          parcels = _data$metadata.parcels,
          productBasedOffers = _data$metadata.productBasedOffers,
          subscriptionTerms = _data$metadata.subscriptionTerms,
          merchandiseIdsTreatedAsOwned = _data$metadata.merchandiseIdsTreatedAsOwned,
          purchaseMotionsByLocation = data.purchaseMotionsByLocation;
      dispatch({
        type: _ActionTypes.default.CUSTOMER_CURRENCY_CODE_RECEIVED,
        payload: customerCurrencyCode
      });
      dispatch({
        type: _ActionTypes.default.SUBSCRIPTION_TERMS_RECEIVED,
        payload: subscriptionTerms
      });
      dispatch({
        type: _ActionTypes.default.PURCHASE_MOTIONS_BY_LOCATION_RECEIVED,
        payload: purchaseMotionsByLocation
      });
      dispatch({
        type: _ActionTypes.default.MERCHANDISE_IDS_TREATED_AS_OWNED_RECEIVED,
        payload: merchandiseIdsTreatedAsOwned
      });
      dispatch({
        type: _ActionTypes.default.PRODUCT_BASED_OFFERS_RECEIVED,
        payload: productBasedOffers
      });
      dispatch({
        type: _ActionTypes.default.PARCELS_RECEIVED,
        payload: parcels
      });
      dispatch({
        type: _ActionTypes.default.PURCHASE_MOTION_DATA_SUCCEEDED
      });
    }).catch(function (error) {
      (0, _dispatchAndThrowError.dispatchAndThrowError)({
        dispatch: dispatch,
        type: _ActionTypes.default.PURCHASE_MOTION_DATA_FAILED,
        error: error
      });
    });
  };
};

exports.fetchPurchaseMotionData = fetchPurchaseMotionData;


//////////////////
// WEBPACK FOOTER
// ./js/actions/PurchaseMotionActions.js
// module id = 888
// module chunks = 5 6